import React from 'react';
import UserAccountAdminSidebar from './UserAccountAdminSidebar';
import UserAccountSidebar from './UserAccountSidebar';
import { useUserState } from '@/components/context/UserContext';
import { Toaster } from 'react-hot-toast';

const UserAccountLayout = ({ children }) => {
  const userState = useUserState();
  const role = userState?.role?.toLowerCase();

  const isAdmin = role === 'affidea' || role === 'popupadmin';
  const accountKey = userState?.espbiEsi || 'self';

  return (
    <div className="flex flex-col sm:flex-row min-h-screen font-primary">
      {/* Sidebar */}
      <aside className="sm:basis-[20%] sm:shrink sm:grow-0 sm:p-5 w-full">
        <UserAccountSidebar />
        <div className="pt-2">
          {isAdmin && <UserAccountAdminSidebar role={role} />}
        </div>
      </aside>

      {/* Main content */}
      <main
        key={accountKey}
        className="sm:basis-[80%] sm:grow sm:shrink w-full sm:p-5"
      >
        {children}
      </main>
      <Toaster position="top-center" />
    </div>
  );
};

export default UserAccountLayout;
